import React, { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import FilterAlt from '@mui/icons-material/FilterAlt';
// import { useTheme } from '@emotion/react';
import './FilterMenu.css';
import { getAllZoneData } from 'api/sentinelAPI';
import { SET_SELECTED_ZONES } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';

const FilterMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]); // Add 'All' as an option
  // const theme = useTheme();
  const dispatch = useDispatch();
  const selectedZone = useSelector((state) => state.customization.selectedZone);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleZoneChange = (event) => {
    // console.log('Event', event);
    const { name, checked } = event.target;
    console.log('Name of filter', name);
    if (checked) {
      dispatch({ type: SET_SELECTED_ZONES, selectedZone: name });
    } else {
      dispatch({ type: SET_SELECTED_ZONES, selectedZone: 'all' });
    }
  };
  useEffect(() => {
    dispatch({ type: SET_SELECTED_ZONES, selectedZone: 'all' });
    const fetchZones = async () => {
      const data = await getAllZoneData();
      const filteredData = data.filter((item) => item.name !== 'entrance');
      setZoneOptions(filteredData);
      // setZoneOptions(data);
    };
    fetchZones();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="cursor-not-allowed">
      <IconButton
        onClick={handleClick}
        disabled
        sx={{
          '&.Mui-disabled': {
            opacity: 0.6
          }
        }}
      >
        <FilterAlt fontSize="large" className="filter-icon" />
      </IconButton>
      <Menu id="filter-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <FormGroup>
          <MenuItem style={{ fontWeight: 'bold' }}>Zone Filter</MenuItem>
          <MenuItem
            sx={{
              paddingTop: 0,
              paddingBottom: 0,
              marginTop: 0,
              marginBottom: 0
            }}
          >
            <FormControlLabel control={<Checkbox checked={selectedZone === 'all'} onChange={handleZoneChange} name="all" />} label="All" />
          </MenuItem>
          {zoneOptions.map((option) => (
            <MenuItem
              key={option.zone_id}
              sx={{
                paddingTop: 0,
                paddingBottom: 0,
                marginTop: 0,
                marginBottom: 0
              }}
            >
              <FormControlLabel
                control={<Checkbox checked={selectedZone === option.name} onChange={handleZoneChange} name={option.name} />}
                label={option.name}
              />
            </MenuItem>
          ))}
        </FormGroup>
      </Menu>
    </div>
  );
};

export default FilterMenu;
